import config from "@Config/index";

/**
 * URLs for images served from the static-assets bucket rather than the bundle.
 *
 * ⚠️  DO NOT `import` an image. Importing lets rspack inline anything under 8KB as
 * base64 and emit the rest under the build's own prefix — both bypass the bucket, so
 * the file ships inside our JS instead of being served and cached by the CDN.
 *
 * The image itself belongs in `public/assets/images/pages/<Page>/assets/` (or
 * `.../components/<Component>/assets/`), which `yarn build:push-public` uploads to
 * `static-assets.amberstudent.com`. `IMAGE_STATIC_ASSETS_*_PATH` resolves to
 * `/assets/images/…` in dev — served straight out of `public/` — and to the S3 static
 * path in production, so one string works in both.
 *
 *   const asset = pageAsset("CareerV2");
 *   const heroImg = asset("hero.jpg");
 */
export const pageAsset =
  (page: string) =>
  (file: string): string =>
    `${config.IMAGE_STATIC_ASSETS_PAGE_PATH}/${page}/assets/${file}`;

/** As `pageAsset`, for an image owned by a shared component. */
export const componentAsset =
  (component: string) =>
  (file: string): string =>
    `${config.IMAGE_STATIC_ASSETS_COMPONENTS_PATH}/${component}/assets/${file}`;
